export enum IntervalPipeType {
  FLEXIBLE = 'FLEXIBLE',
  RIGID = 'STEEL_PIPE',
  CABLE = 'CABLE',
  END_FITTING = 'END_FITTING',
  UNKNOWN = 'UNKNOWN',
}
